import React, { Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  Switch,
  useHistory
} from "react-router-dom";
import axios from "axios";
import ErrorPage from "./pages/ErrorPage";
import MainPage from "./pages/MainPage";
import SubPageTemplate from "./pages/templates/SubPageTemplate";
import RibbonsPage from "./pages/RibbonsPage";
import InventoryPage from "./pages/InventoryPage";
import AchievementsPage from "./pages/AchievementsPage";
import CollectionsPage from "./pages/CollectionsPage";
import CollectionsLeaderPage from "./pages/CollectionLeadersPage";
import ProfileManagerPage from "./pages/ProfileManagerPage";
import RankedStatsPage from "./pages/RankedStatsPage";
import { pageHeaderData } from "./pages/sampleData/sampleData";

import { pagePaths, prefixURI, error404url, hideFooter, _link } from "./common/utilities";

//we are assuming page will be just one directory deep
//from hostname (e.g. /<something>)
// const prefixURI  =
//   '/' + window.location.pathname.split('/')[1];

//SubPages will be replaced with their proper pages
//when those proper pages are developed
function SubPage(props) {
  const { path, location } = props;

  return (
    <SubPageTemplate
      headerData={pageHeaderData}
      headingLeft={path}
      location={location}
    >
      {path} content
    </SubPageTemplate>
  );
}

function getRenderPropsPage(pageName) {
  return props => {
    //do common actions before rendering page on route change
    hideFooter();

    //get page component for route change
    switch (pageName) {
      case "ERROR":
        return <ErrorPage key={props.location.key} {...props} />;
      case "MAIN":
        return <MainPage key={props.location.key} {...props} />;
      case "PROFILE_MANAGER":
        return <ProfileManagerPage key={props.location.key} {...props} />;
      case "RANKED_STATS":
        return <RankedStatsPage key={props.location.key} {...props} />;
      case "ACHIEVEMENTS":
        return <AchievementsPage key={props.location.key} {...props} />;
      case "RIBBONS":
        return <RibbonsPage key={props.location.key} {...props} />;
      case "COLLECTONS":
        return <CollectionsPage key={props.location.key} {...props} />;
      case "COLLECTONS_LEADERS":
        return <CollectionsLeaderPage key={props.location.key} {...props} />;
      case "INVENTORY":
        return <InventoryPage key={props.location.key} {...props} />;
      default:
        window.location = error404url;
    }
  };
}

let gnbInterval;

//https://stackoverflow.com/questions/32261441/component-does-not-remount-when-route-parameters-change
//assign key value to ensure component unmount/remount
//on route change - even if route change is by clicking on link
//that redirects to page we are currently on
export default function App() {
  useEffect(() => {
    //prevent user from logging out - calling gnb.js will refresh cookies
    gnbInterval = setInterval(() => {
      axios.get(`${_link['gnb_cf_url']}`); 
    }, 600000);  //10min    

    return () => clearInterval(gnbInterval);
  },[]);

  return (
    <Suspense fallback={<div></div>}>
      <Router>
        <Switch>
          <Route
            exact
            path={`${prefixURI}/error`}
            render={getRenderPropsPage('ERROR')}
          />
          <Route
            exact
            path={`${prefixURI}/:usn(\\d+)`}
            render={getRenderPropsPage('MAIN')}
          />
          <Route
            exact
            path={`${prefixURI}/:usn(\\d+)/${pagePaths.PROFILE_MANAGER}`}
            render={getRenderPropsPage('PROFILE_MANAGER')}
          />
          <Route
            exact
            path={`${prefixURI}/:usn(\\d+)/${pagePaths.RANKED_STATS}`}
            render={getRenderPropsPage('RANKED_STATS')}
          />
          <Route
            exact
            path={`${prefixURI}/:usn(\\d+)/${pagePaths.ACHIEVEMENTS}`}
            render={getRenderPropsPage('ACHIEVEMENTS')}

          />
          <Route
            exact
            path={`${prefixURI}/:usn(\\d+)/${pagePaths.RIBBONS}`}
            render={getRenderPropsPage('RIBBONS')}

          />
          <Route
            exact
            path={`${prefixURI}/:usn(\\d+)/${pagePaths.COLLECTONS}`}
            render={getRenderPropsPage('COLLECTONS')}
          />
          <Route
            exact
            path={`${prefixURI}/:usn(\\d+)/${pagePaths.COLLECTONS}/:cid`}
            render={getRenderPropsPage('COLLECTONS_LEADERS')}
          />
          <Route
            exact
            path={`${prefixURI}/:usn(\\d+)/${pagePaths.INVENTORY}`}
            render={getRenderPropsPage('INVENTORY')}
          />
          <Route
            exact
            path="*"
            component={() => (window.location = error404url)}
          />
        </Switch>
      </Router>
    </Suspense>
  );
}
